export class Vaga {
  id!: number;
  idCargo!: number;
  titulo!: string;
  descricao!: string;
  situacao!: string;
  situacaoF!: boolean;
}
